import { render, staticRenderFns } from "./Bell.vue?vue&type=template&id=7d0451ea&scoped=true&"
import script from "./Bell.vue?vue&type=script&lang=js&"
export * from "./Bell.vue?vue&type=script&lang=js&"
import style0 from "./Bell.vue?vue&type=style&index=0&id=7d0451ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0451ea",
  null
  
)

export default component.exports